import React from 'react';
import { connect } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { INVENTORY_API_BASE_URL_2, ORG_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import Ax from '../../../components/hoc/Ax';
import tapIcon from '../../../services/TapIcon';
import { Modal } from 'bootstrap';
import Loader from '../../../components/ui/Loader/Loader';
import TapSelect from '../../../components/ui/TapSelect';
import { toast } from 'react-toastify';
import AppBaseComponent from '../../../components/AppBaseComponent';
import uuid from 'react-uuid';
import api from '../../../services/api';

class SalesOrderDocumentModal extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.documentInitialState    =  { 
            name                        :   "",
            number                      :   "",
            photo                       :   null,
        }

        this.state                   =  {
            load_form                   :   false,
            documentSubmitting          :   false,
            other                       :   'N',
            addDocumentForm             :   {...this.documentInitialState},
            documentTypes               :   [],
            salesOrderDetail            :   null,
        };
       
        this.modalId                    =    uuid();   

        this.iscDocTypeUrl      =   ORG_API_BASE_URL_2  + '/setting/isc_doc_types';
        this.soDocUrl           =   INVENTORY_API_BASE_URL_2 + '/sales_order/doc_add';
       
    }

    componentDidMount(){
        this.addDocModal                =   new Modal(document.getElementById(this.modalId), {keyboard: false, backdrop :false});
    }

    loadDocTypesFromApi                 =   ()  =>  {
        this.setState({formDataLoading: true})
        
    }

    showModalInit           =   ()  =>  {  
        this.addDocModal.show();
        this.setState({
            load_form           :   true,
            documentSubmitting  :   false,
            salesOrderDetail      :   {...this.props.salesOrderDetail},
            addDocumentForm: { ...this.documentInitialState }, 
            other: 'N'
        });

        HttpAPICall.withAthorization('GET', this.iscDocTypeUrl, this.props.access_token , {}, {}, (response) => {
            this.setState({
                documentTypes   :   response.data.map(s => {return({value : s , label : s})}),
            });
        }, (error) => {
            toast.error(error?.msg, { position: toast.POSITION.TOP_RIGHT });
        }).then(() => this.setState({load_form: false}))

    }

    handleFileChange = (e) => {
        let file = e.target.files[0];
        this.setState({ addDocumentForm: { ...this.state.addDocumentForm, photo: file } });
    }

    addDocument =   (e) => {
        e.preventDefault();
        this.setState({documentSubmitting : true});
        const transaction_id      =   this.state.salesOrderDetail && this.state.salesOrderDetail.transaction_id;

        const formData = new FormData();
        formData.append('name',           this.state.addDocumentForm.name);
        formData.append('number',         this.state.addDocumentForm.number);
        formData.append('document',          this.state.addDocumentForm.photo);
        formData.append('transaction_id', transaction_id);

        const headers = { Authorization: 'Bearer ' + this.props.access_token };
        api.server2Api.post(this.soDocUrl, formData, { headers })
            .then(response => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                this.props.getDetails(transaction_id);
                this.addDocModal.hide();
            })
            .catch(error => toast.error(error?.response?.data?.msg, { position: toast.POSITION.TOP_RIGHT }))
            .finally(() => this.setState({ documentSubmitting: false }));
    }

    render() {
        return (
            <div className="modal fade" id={this.modalId} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content  ">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addDocModalLabel">Add Document</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        { this.state.load_form 
                        ? <Loader/>
                        : <Ax>
                            <form onSubmit={this.addDocument}>
                                <div className="modal-body">
                                    <div className="row align-items-center">
                                        <div className="col-md-3">
                                            <label className="form-label require">Document Type</label>
                                        </div>
                                        <div className="col-sm-7">
                                            {
                                                this.state.other == "Y"
                                                ? <input
                                                    name="name"
                                                    type="text"
                                                    value={this.state.addDocumentForm.name}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => this.formInputHandler(e, "addDocumentForm")}
                                                    placeholder="Please enter Type Name"
                                                    required={true}
                                                // autoFocus={true}
                                                />
                                                : <TapSelect
                                                    options={this.state.documentTypes}
                                                    changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'addDocumentForm', 'name')}
                                                    value={this.state.documentTypes.find(u => this.state.addDocumentForm.name == u.value)}
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    placeholder="Select Document Type"
                                                    autoCompelete="off"
                                                    required={true}
                                                    autoFocus={true}
                                                />
                                            }
                                        </div>
                                        <div className="col-sm-2">
                                            <input
                                                name="other"
                                                type="checkbox"
                                                value={this.state.other}
                                                onChange={(e) => { this.setState({ other: this.state.other == 'N' ? 'Y' : 'N' }) }}
                                                checked={this.state.other == 'Y'}
                                                className="form-check-input"
                                                id="other"
                                            />
                                            <label className="form-check-label mx-2" htmlFor="other">New </label>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-sm-3">
                                            <label className="form-label">Document Number</label>
                                        </div>
                                        <div className="col-md-7">
                                            <input
                                                name="number"
                                                type="text"
                                                value={this.state.addDocumentForm.number}
                                                onChange={(e) => this.formInputHandler(e, "addDocumentForm")}
                                                className="form-control"
                                                autoComplete="off"
                                                placeholder="Enter Document Number"
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-3">
                                            <label className="form-label require">Document</label>
                                        </div>
                                        <div className="col-md-7">
                                            <input
                                                name="photo"
                                                type="file"
                                                onChange={(e) => this.handleFileChange(e)}
                                                className="form-control"
                                                autoComplete="off"
                                                required={true}
                                            />
                                        </div>

                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" disabled={this.state.documentSubmitting} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    <button type="submit" disabled={this.state.documentSubmitting} className="btn btn-primary">Submit {this.state.documentSubmitting && <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />}</button>
                                </div>
                            </form>
                            </Ax>
                        }
                    </div>
                </div>
            </div>
        )
    }

}


const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
    };
};

export default connect(mapStateToProps,null, null, { forwardRef: true })(SalesOrderDocumentModal);